import { FileText } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface GdprConsentProps {
  haveGdpr: boolean;
  isEditMode: boolean;
  onGdprChange: (checked: boolean) => void;
}

export default function GdprConsent({ haveGdpr, isEditMode, onGdprChange }: GdprConsentProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <FileText className="h-5 w-5" />
          Consimțământ GDPR
        </CardTitle>
        <CardDescription>
          {isEditMode
            ? 'Consimțământul GDPR a fost deja acceptat pentru această sesiune.'
            : 'Pentru a continua, trebuie să acceptați consimțământul pentru prelucrarea datelor personale.'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-start space-x-3 p-4 bg-muted/50 rounded-lg">
          <Checkbox
            id="gdpr"
            checked={haveGdpr}
            disabled={isEditMode}
            onCheckedChange={(checked) => {
              if (!isEditMode) {
                onGdprChange(!!checked);
              }
            }}
          />
          <div className="space-y-1">
            <Label htmlFor="gdpr" className="font-medium cursor-pointer">
              Accept prelucrarea datelor personale conform GDPR
            </Label>
            <p className="text-sm text-muted-foreground">
              Datele vor fi folosite exclusiv în scopuri medicale și nu vor fi partajate cu terți fără consimțământ.
            </p>
          </div>
        </div>
        {!haveGdpr && !isEditMode && (
          <p className="text-sm text-destructive mt-2">
            Trebuie să acceptați consimțământul GDPR pentru a continua
          </p>
        )}
      </CardContent>
    </Card>
  );
}
